<style>
  .title {
    font-size: 20px;
  }
</style>
<template>
  <div class="customer-setting">
    <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition" :overlay="false" max-width="960px">
      <v-card class="background: secondary" pl-2>
        <v-toolbar fixed flat height="60px">
          <v-spacer></v-spacer>
          <v-toolbar-title class="justify-center headline primary--text">
            {{ $t('Nastavení účtu') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn id="revert-button" icon @click="revertChanges" @click.native="dialog = false" v-on="on">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Zrušení změn') }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container fluid class="background: secondary">
            <v-alert type="error" :value="this.$error.hasStatus">{{ $t(this.$error.alertResponse) }}</v-alert>
            <div class="d-flex justify-space-between">
            <div class="caption">{{ $t('Obrázek') }}</div>
<!--            <div class="caption grey&#45;&#45;text">{{ $t('Vyberte si svůj obrázek') }}</div>-->
            </div>
            <v-row>
              <v-col xs="6" class="text-right">
                <v-list-item-avatar size="80" v-if="hasImage">
                  <img :src="this.customerImage.url" @click="onPickImage" style="cursor: pointer;">
                </v-list-item-avatar>
                <v-list-item-avatar size="80" v-else>
                  <i class="fa fa-user fa-4x" @click="onPickImage" style="cursor: pointer;"></i>
                </v-list-item-avatar>
              </v-col>
              <v-col xs="4" class="text-left pt-8 pl-8">
                <v-btn color="primary" @click="deleteImage" v-if="hasImage">{{ $t('Odstranit obrázek') }}</v-btn>
                <v-btn color="primary" @click="onPickImage" v-else>{{ $t('Přidat obrázek') }}</v-btn>
                <input type="file" style="display: none" ref="image" accept="image/*" @change="onImagePicked" hidden>
              </v-col>
            </v-row>
            <div class="d-flex justify-space-between my-3">
              <div class="caption">{{ $t('Osobní údaje') }}</div>
<!--              <div class="caption grey&#45;&#45;text">{{ $t('Vyplňte jméno a příjmení') }}</div>-->
            </div>
            <div class="d-flex justify-space-between">
              <setting-name id="name-setting" label="name" v-model="customer"></setting-name>
            </div>
            <div class="d-flex justify-space-between my-3">
              <div class="caption">{{ $t('Kontaktní údaje') }}</div>
<!--              <div class="caption grey&#45;&#45;text">{{ $t('Vyplňte kontaktní email a telefon') }}</div>-->
            </div>
            <v-row>
              <v-col cols="12" sm="6" xs="12" class="ma-0 pl-2 pr-3 py-0">
                <setting-email label="email" v-model="email" required></setting-email>
              </v-col>
              <v-col cols="12" sm="6" xs="12" class="my-3 pl-3 pr-5 py-0">
                <setting-phone id="phone" v-model="phone" required></setting-phone>
              </v-col>
            </v-row>
            <div class="d-flex justify-space-between my-3">
                <div class="caption">{{ $t('Doručovací adresa') }}</div>
<!--                <div class="caption grey&#45;&#45;text">{{ $t('Vyplňte doručovací adresu') }}</div>-->
              </div>
            <v-row>
              <v-col cols="12" class="ma-0 px-2 py-0">
                <setting-address label="address" v-model="customer.invoiceAddress" :default-value="defaultAddress"
                                 required></setting-address>
              </v-col>
            </v-row>
            <div class="d-flex justify-space-between my-3">
            <div class="caption">{{ $t('Fakturační údaje') }}</div>
<!--                <div class="caption grey&#45;&#45;text">{{ $t('Vyplňte údaje o společnosti pokud nakupujete na firmu') }}</div>-->
              </div>
            <v-row>
              <v-col cols="12" class="ma-0 px-2 py-0">
                <setting-company label="email" v-model="customer.customer" required></setting-company>
              </v-col>
            </v-row>
<!--              s-->
            <div class="d-flex justify-space-between my-3">
            <span class="caption">{{ $t('Informovaný souhlas') }}</span>
<!--                <div class="caption grey&#45;&#45;text">{{ $t('Nastavte souhlas se zpracováním osobních údajů') }}</div>-->
              </div>
            <v-row>
              <v-col cols="12" class="ma-0 px-2 py-0">
                <my-gdpr v-model="customerData.gdprStates"></my-gdpr>
              </v-col>
            </v-row>
          </v-container>
          <!-- <v-divider></v-divider>
          <v-container fluid grid-list-md class="background: secondary">
            <v-row mt-3 mb-3>
              <v-col cols="12" sm5 mt-3>
                <span class="subtitle-1">{{ $t('Odběr novinek') }}</span>
                <div class="caption grey--text">{{ $t('Přihlašte se k odběru mimořádných nabídek a informací') }}</div>
              </v-col>
              <v-col cols="12" sm7 mt-3>
                <v-checkbox v-model="customer.extraOffersOn" :label="$t('Přihlásit')"></v-checkbox>
              </v-col>
            </v-row>
          </v-container> -->

        </v-form>
        <v-card-actions class="background: secondary">
          <v-col cols="12" class="text-center">
            <v-tooltip>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" id="save-button" @click="saveChanges" @click.native="dialog = false" v-on="on"
                       :disabled="!valid || (!changedCustomer && !changedGdpr)">{{ $t('Uložit změny') }}
                </v-btn>
              </template>
              <span>{{ $t('Uložení změn') }}</span>
            </v-tooltip>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import CustomerMixin from '@/mixins/customer-mixin.js'
    import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'
    // import SelectTitle from '@gravela/vue-component-library/src/components/select-title.vue'
    import SettingEmail from '@gravela/vue-component-library/src/components/setting-email.vue'
    import SettingPhone from '@gravela/vue-component-library/src/components/setting-phone.vue'
    import SettingAddress from '@gravela/vue-component-library/src/components/setting-address.vue'
    import SettingName from '@gravela/vue-component-library/src/components/setting-name.vue'
    import SettingCompany from '@gravela/vue-component-library/src/components/setting-company.vue'
    import MyGdpr from '@/components/my-gdpr.vue'

    const _ = require('lodash')

    export default {
        props: {
            visible: {
                type: Boolean
            }
        },
        mixins: [CustomerMixin, TransformMixin],
        components: {
            SettingEmail,
            SettingPhone,
            SettingAddress,
            SettingName,
            SettingCompany,
            MyGdpr
        },
        data() {
            return {
                cachedCustomer: null,
                cachedGdpr: null,
                filename: null,
                formData: null,
                news: false,
                newPassword: null,
                valid: true,
                titlesFront: [],
                titlesAfter: [],
                addressType: null,
                emailType: null,
                phoneType: null,
                hasImage: this.customerImageUrl !== null
            }
        },
        computed: {
            dialog: {
                get() {
                    return this.visible
                },
                set(value) {
                    if (!value) {
                        this.$emit('close')
                    }
                }
            },
            phone: {
                get() {
                    return this.customerPhoneNo || this.customer.phoneNo
                },
                set(value) {
                    this.customer.workingPhoneNo = value
                }
            },
            email: {
                get() {
                    return this.customer.workingEMail || this.customer.eMail
                },
                set(value) {
                    this.customer.workingEMail = value
                }
            },
            defaultAddress: {
                get() {
                    return {
                        'addressName': this.addressName
                    }
                }
            },
            emailRequired: {
                get() {
                    return this.emailType === 'contactEmail'
                }
            },
            phoneRequired: {
                get() {
                    return this.phoneType === 'contactPhone'
                }
            },
            addressRequired: {
                get() {
                    return this.addressType === 'contactAddress'
                }
            },
            changedCustomer: {
                get() {
                    return !_.isEqual(this.cachedCustomer, this.customer)
                }
            },
            changedGdpr: {
                get() {
                    return !_.isEqual(this.cachedGdpr, this.customerData.gdprStates)
                }
            }
        },
        methods: {
            revertChanges() {
                if (this.cachedCustomer) {
                    this.customer.customer = JSON.parse(JSON.stringify(this.cachedCustomer))
                }
                if (this.cachedGdpr) {
                    this.customerData.gdprStates = JSON.parse(JSON.stringify(this.cachedGdpr))
                }
            },
            saveChanges() {
                if (this.changedCustomer) {
                    this.$fetch('my/customers', {
                        method: 'PUT',
                        body: JSON.stringify(this.customer)
                    }).then(data => {
                        this.customer.customer = data
                        this.cachedCustomer = JSON.parse(JSON.stringify(this.customer))
                    }).catch(() => console.log('cust put error'))
                }
                if (this.changedGdpr) {
                    this.setGdprStates(this.customerData.gdprStates).then(() => {
                        this.cachedGdpr = JSON.parse(JSON.stringify(this.customerData.gdprStates))
                    })
                }
            },
            onPickImage() {
                this.$refs.image.click()
            },
            onImagePicked(event) {
                const files = event.target.files || event.dataTransfer.files
                if (files && files[0]) {
                    const fileReader = new FileReader()
                    fileReader.addEventListener('load', () => {
                        this.customerImage.url = fileReader.result
                    })
                    fileReader.readAsDataURL(files[0])
                    var formData = new FormData()
                    formData.append('image', files[0])
                    // formData.append('name', this.imageFile.name)
                    // formData.append('upload_file', true)
                    this.$fetch('customers/myself/images', {
                        headers: {
                            'content-type': 'multipart/form-data'
                        },
                        method: 'POST',
                        body: formData
                    }).then(() => this.hasImage = true).catch(() => console.log('image upload error'))
                }
            },
            deleteImage() {
                if (this.hasImage) {
                    this.$fetch('customers/myself/images', {
                        method: 'DELETE'
                    }).then(() => {
                        this.customerImage = {}
                        this.hasImage = false
                        this.$refs.image.value = ''
                    }).catch(() => console.log('image delete error'))
                }
            }
        },
        watch: {
            dialog() {
                if (this.visible) {
                    this.cachedCustomer = JSON.parse(JSON.stringify(this.customer))
                    this.cachedGdpr = JSON.parse(JSON.stringify(this.customerData.gdprStates))
                }
            },
            hasAgreement(value) {
                if (!value && this.isRegistered && this.hasCustomer) {
                    this.$router.push({
                        name: 'home'
                    }).catch(console.log)
                }
            }
        }
    }
</script>
